/**
 * 缓存配置 — 三层分级
 *
 * session:   认证状态（准静态，依靠 invalidateQueries + refetchOnWindowFocus 保鲜）
 * reference: 参考数据（categories, shops, regions, rankings — ETL 周期更新，无需频繁刷新）
 * default:   用户交互数据（favorites, notes — 通过 mutation invalidation 保鲜）
 */
export const CACHE_CONFIG = {
  session: {
    staleTime: import.meta.env.PROD ? 1000 * 60 * 30 : 0,     // 生产环境 30 分钟，开发/测试环境 0 以免缓存脏的 SSR 状态
    gcTime: 1000 * 60 * 60,        // 60 分钟
  },
  reference: {
    staleTime: 1000 * 60 * 60 * 24,     // 24 小时 (ETL 周更，无须频繁刷新)
    gcTime: 1000 * 60 * 60 * 48,        // 48 小时
  },
  default: {
    staleTime: 1000 * 60 * 5,      // 5 分钟
    gcTime: 1000 * 60 * 30,        // 30 分钟
  },
} as const
